import React, { Component } from "react";
import {
    connectCurrentRefinements,
    connectStateResults,
    ClearRefinements
} from "react-instantsearch-dom";
import PropTypes from "prop-types";

class Clear extends Component {
    static propTypes = {
        linkText: PropTypes.string,
        items: PropTypes.array,
        searchState: PropTypes.shape({
            query: PropTypes.string
        })
    };

    render() {
        const {
            linkText,
            items,
            searchState: { query }
        } = this.props;

        return items.length || query ? (
            <ClearRefinements
                clearsQuery={true}
                translations={{ reset: linkText }}
            />
        ) : null;
    }
}

export default connectCurrentRefinements(connectStateResults(Clear));



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Clear.js